export enum IngestProcessingState {
  FileReceived = "FileReceived",
  FileUploading = "FileUploading",
  FileRejected = "FileRejected",
  FileProcessingError = "FileProcessingError",
  FileUploadStuck = "FileUploadStuck",
  FileMissing = "FileMissing",
}
